import { forwardRef } from "react";

const styledAnchor = { position: "relative", top: -64 };

// eslint-disable-next-line
export const refScroll = (ref: React.RefObject<any>) =>
  ref?.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });

const ScrollAnchor = forwardRef<HTMLDivElement>((_, ref) => (
  <div ref={ref} style={styledAnchor as React.CSSProperties} />
));

// Needed by React to display names on forwardRef components
ScrollAnchor.displayName = "ScrollAnchor";

export default ScrollAnchor;
